/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ChangeOrderTargetDateTimeCommandFromJSON(json) {
    return ChangeOrderTargetDateTimeCommandFromJSONTyped(json, false);
}
export function ChangeOrderTargetDateTimeCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'newTargetDate': !exists(json, 'newTargetDate') ? undefined : (new Date(json['newTargetDate'])),
    };
}
export function ChangeOrderTargetDateTimeCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'newTargetDate': value.newTargetDate === undefined ? undefined : (value.newTargetDate.toISOString()),
    };
}
